import React, { useCallback, useState } from 'react'
import { Form } from 'react-final-form'
import { AutocompleteInput, FormDataConsumer, TextInput } from 'react-admin'

import { Box, Button, Grid } from '@material-ui/core'

import { useFilterList } from 'components/List/FilterContext'
import { Range } from 'components/DateRangePicker/types'

import { DateRangePicker, ResourceSelector } from 'components'


export const FilterApp: React.FC<{
  filterLesson: boolean,
  filterPerson: boolean,
  filterUser: boolean,
  filterCourse: boolean
}> = ({ children, filterLesson, filterPerson, filterUser, filterCourse }) => {
  const { onCloseFilterModal, setFilters } = useFilterList()
  const [range, setRange] = useState<Range>({ startAt: null, endAt: null })

  const onSubmit = (values: any) => {
    const filters = values

    if (values.course_id) {
      filters['grouper_id'] = values.course_id
    }

    if (filterLesson) {
      if (values.week_id) {
        filters['grouper_id'] = values.week_id
      }
    }


    if (values.id) {
      filters['id'] = values.id
    }


    if (range && range.startAt && range.endAt) {
      filters['released_at'] = range
    }

    delete filters['course_id']

    if (filterLesson) {
      delete filters['week_id']
    }

    setFilters(filters, filters)
    onCloseFilterModal()
  }

  const handleOnClear = useCallback(() => {
    setFilters({}, {})
    setRange({ startAt: null, endAt: null })
  }, [])

  const handleSetRage = useCallback((value: Range) => {
    setRange((old) => ({ ...old, ...value }))
  }, [])

  return (
    <Form onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <FormDataConsumer>
          {({ formData }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={0}>
                {filterCourse || filterLesson ?
                  <>
                    <Grid item xs={12}>
                      <Box marginBottom="26px">
                        <DateRangePicker
                          labelStartAt="Data inicial de lançamento"
                          labelEndAt="Data final de lançamento"
                          onChange={handleSetRage}
                          values={range}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <ResourceSelector
                        fullWidth
                        label="Curso/Série"
                        resource="cms/grouper/courses"
                        source="course_id"
                        optionValue="id"
                        sendFilter={"title"}
                      />
                    </Grid>
                  </> : null
                }

                {filterPerson ?
                  <Grid item xs={12}>
                    <ResourceSelector
                      fullWidth
                      label="Nome"
                      resource="cms/content/involved_people"
                      source="id"
                      optionValue="id"
                      sendFilter={"name"}
                    />
                  </Grid> : null}

                {filterUser ?
                  <Grid item xs={12}>
                    <ResourceSelector
                      fullWidth
                      label="Email"
                      resource="cms/users"
                      source="id"
                      optionValue="id"
                    />
                  </Grid> : null}

                {filterLesson ?
                  <>
                    <Grid item xs={12}>
                      <ResourceSelector
                        fullWidth
                        label="Semana"
                        resource="cms/grouper/week"
                        source="week_id"
                        optionValue="id"
                        filter={{
                          ...(formData?.course_id
                            ? { grouper_id: formData.course_id }
                            : {}),
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <AutocompleteInput
                        fullWidth
                        resettable
                        label="Status"
                        source="status"
                        choices={[
                          {
                            id: 'pendente',
                            name: 'Pendente',
                          },
                          {
                            id: 'concluido',
                            name: 'Concluído',
                          },
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <AutocompleteInput
                        fullWidth
                        resettable
                        label="Tipo de Aula"
                        source="type"
                        choices={[
                          {
                            id: 'enterprising',
                            name: 'Aula com Empreendedor',
                          },
                          {
                            id: 'techniques',
                            name: 'Aula com o Especialista',
                          },
                          { id: 'liveclass', name: 'Liveclass' },
                          { id: 'documentary', name: 'Documentário' },
                          { id: 'extra', name: 'Aula Extra' },
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <ResourceSelector
                        fullWidth
                        label="Título"
                        resource="cms/grouper/lesson"
                        source="lesson_id"
                        optionValue="id"
                      />
                    </Grid>
                  </> :
                  null
                }

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={1} justifyContent="flex-end">
                    <Grid item>
                      <Button variant="outlined" color="primary" type="submit">
                        Filtrar
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button variant="outlined" onClick={handleOnClear}>
                        Limpar
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button variant="outlined" onClick={onCloseFilterModal}>
                        Fechar
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          )}
        </FormDataConsumer>
      )}
    </Form>
  )
}
